import React, { Suspense } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useStore } from '../State';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { order } = useStore();
  return (
    <Route
      {...rest}
      render={props =>
        order.exists() ? (
          <Suspense fallback={<div />}>
            <Component {...props} />
          </Suspense>
        ) : (
          <Redirect
            to={{
              pathname: `/${props.match.params.merchantReference}`,
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
